import PropTypes from 'prop-types';
import BasePotreeViewer from './BasePotreeViewer';

function PotreeViewer({ filename, description, metadata, hierarchy, octree }) {
  return (
    <BasePotreeViewer
      filename={filename}
      description={description}
      metadata={metadata}
      hierarchy={hierarchy}
      octree={octree}
      showTranslations={true}
    />
  );
}

PotreeViewer.propTypes = {
  filename: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  metadata: PropTypes.string.isRequired,
  hierarchy: PropTypes.string.isRequired,
  octree: PropTypes.string.isRequired
};

export default PotreeViewer;
